// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2U9jd","footer":"ReportModalFilter_footer__1yVAf"};